import GloballySelected from "../../../../common/state/modules/globallySelected";
import SingleSelectedProperty from "../../../../common/state/modules/singleSelectedProperty";
import ListView from "../../../../common/models/listViews/listView";
import DetailView from "../../../../common/models/detailView/detailView";
import ObjectModelEntry from "../../../../common/models/objectModelEntries/objectModelEntry";
import PublishedListView from "../../../../common/models/listViews/publishedListView";
import PublishedDetailView from "../../../../common/models/detailView/publishedDetailView";

type TModelView = ListView | DetailView;
type TDetailView = DetailView | PublishedDetailView
export default class Selected extends GloballySelected {
  static listView = new SingleSelectedProperty('listView', () => ListView);
  static publishedListView = new SingleSelectedProperty('publishedListView', () => PublishedListView);
  static unpublishedDetailView = new SingleSelectedProperty('detailView', () => DetailView);
  static publishedDetailView = new SingleSelectedProperty('publishedDetailView', () => PublishedDetailView);
  static objectModelEntry = new SingleSelectedProperty("objectModelEntry", () => ObjectModelEntry);
  static get detailView(): TDetailView{
    return Selected.publishedDetailView.get() || Selected.unpublishedDetailView.get()
  }
  static get modelView(): TModelView {
    return Selected.listView.get() || Selected.detailView;
  }
}